/**
 * Create Articles context for custom hook
 */

import { createContext } from 'react'

const ArticlesContext = createContext({
  fetchArticlesCategories: () => {},

})

export default ArticlesContext
